export type GridUrlState = {
  fm?: string; // filterModel JSON (encodeURIComponent(JSON.stringify(...)))
  sm?: string; // sortModel JSON
  s?: string; // selected chips (comma-separated)
  df?: string; // dateFrom (yyyy-MM-dd)
  dt?: string; // dateTo   (yyyy-MM-dd)
  q?: string; // optional: quickFilter input (jen pro čitelnost; redundance s fm.quickFilterValues)
};

export const encodeJson = (obj: unknown) => encodeURIComponent(JSON.stringify(obj));
export const decodeJson = <T>(val?: string | null): T | undefined => {
  if (!val) return;
  try {
    return JSON.parse(decodeURIComponent(val)) as T;
  } catch {
    return;
  }
};

export const getParams = (search: string): GridUrlState => {
  const sp = new URLSearchParams(search);
  return {
    fm: sp.get('fm') || undefined,
    sm: sp.get('sm') || undefined,
    s: sp.get('s') || undefined,
    df: sp.get('df') || undefined,
    dt: sp.get('dt') || undefined,
    q: sp.get('q') || undefined
  };
};

export const setParams = (currentSearch: string, next: Partial<GridUrlState>) => {
  const sp = new URLSearchParams(currentSearch);
  Object.entries(next).forEach(([k, v]) => {
    if (v == null || v === '') sp.delete(k);
    else sp.set(k, v as string);
  });
  return `?${sp.toString()}`;
};
